import { create } from 'zustand';

/**
 * Tiny global store for the in-app install modal. Any component can
 * call `openInstallModal()` to show it; the modal is mounted once at
 * the app root (main.tsx) and consumes the open flag from here.
 */
interface InstallModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useInstallModal = create<InstallModalState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

export function openInstallModal() {
  useInstallModal.getState().setOpen(true);
}
